import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { ModalProps } from 'features/modals';
import { JobLabelEdit } from 'pages/Settings/Labels/job-labels';

type Props = ModalProps<{
  onSuccess: (label: string, value: number, color: string) => void;
}>;

export const AddJobLabelModal = (props: Props) => {
  const { onSuccess } = props;
  const { t } = useScopedTranslate(locale);
  const handleSubmit = async () => {
    props.closeModal();
  };
  return (
    <Stack space={6}>
      <Text font="heading1" text={t('addLabel')} />
      <JobLabelEdit inlineEdit={false} setIsEdit={handleSubmit} onCreateSuccess={onSuccess} />
    </Stack>
  );
};

const locale = {
  en: {
    addLabel: 'Add job label',
    cancel: 'Cancel',
    save: 'Save',
  },
  is: {
    addLabel: 'Bæta við merki starfs',
    cancel: 'Hætta við',
    save: 'Vista',
  },
};
